import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Silence the harmless "ResizeObserver loop" warning that Radix UI Select
// emits inside shadcn Dialogs. Per the W3C ResizeObserver spec note this
// signal is benign, but CRA's dev error overlay treats every window 'error'
// event as a runtime crash and renders a red modal that intercepts clicks.
//
// CRA registers its overlay listener before user code, so we MUST use
// { capture: true } to run before it; we also patch console.error since
// CRA's overlay client also hooks it.
if (typeof window !== "undefined") {
  const _RO_RE = /ResizeObserver loop (limit exceeded|completed with undelivered notifications)/;
  const _swallow = (e) => {
    const msg = e && (e.message || (e.error && e.error.message)) || "";
    if (_RO_RE.test(msg)) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  };
  window.addEventListener("error", _swallow, true);

  // Belt-and-suspenders: defer ResizeObserver callbacks to rAF so the loop
  // warning never fires in the first place (community-standard workaround).
  if (typeof window.ResizeObserver === "function") {
    const _Orig = window.ResizeObserver;
    window.ResizeObserver = class extends _Orig {
      constructor(cb) {
        super((entries, observer) => {
          window.requestAnimationFrame(() => {
            try { cb(entries, observer); } catch (_) { /* swallow */ }
          });
        });
      }
    };
  }

  // CRA overlay client v4+ also taps console.error — filter the same message.
  const _origConsoleError = window.console.error;
  window.console.error = (...args) => {
    const first = args && args[0];
    const msg = typeof first === "string" ? first : (first && first.message) || "";
    if (_RO_RE.test(msg)) return;
    _origConsoleError.apply(window.console, args);
  };
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
